class LessonMenuView extends Backbone.View
  events:
    "iostap #lesson-menu-exit": "exit"
    "iostap #lesson-menu-go-back": "back"
    "iostap #lesson-menu-restart": "restart"
    "iostap #lesson-menu-cancel": "close"

  initialize: (@options) ->
    @pageNumber = @el.querySelector("#lesson-menu-page-count")

  open: ->
    @el.classList.add("active")

  close: ->
    @el.classList.remove("active")

  exit: ->
    @options.exit()
    Backbone.Events.trigger "application-exit"
    Application.publish("event:menu-exit") {}

  back: ->
    @options.back()
    @close()

  restart: ->
    @options.restart()
    @close()

  updateStyle: ({ colors, background } = {}) ->
    image = if background? then "url(#{background})" else ""
    { text, background } = colors or {}

    @el.style.backgroundImage = image
    @el.style.backgroundColor = background
    @el.style.color = text

  setPage: (index) ->
    total = @pageNumber.dataset.total
    if @options.isQuiz
      @pageNumber.innerHTML = window.marked(
        i18n("menu.brainboost-page-count", { index: index + 1, total })
      )
    else 
      @pageNumber.innerHTML = window.marked(
        i18n("menu.page-count", { index: index + 1, total })
      )

    $(@el).removeClass (index, classes) ->
      return (classes.match(/page-\d+/g) || []).join(" ")
    @el.classList.add("page-#{@currentIndex = index}")

module.exports = LessonMenuView
